<div class="detail-info-type-field" [class.hide-label]="hideLabel">
  <ng-container [ngSwitch]="detailInfo.controllerType">
    <ng-container *ngSwitchCase="ControllerTypes.TextBox">
      <detail-info-textbox
        class="w-100"
        [detailInfo]="detailInfo"
        [noDefaultValue]="noDefaultValue"
        [formControlObj]="control(detailInfo.evideInputContentGuid.toString())"
      ></detail-info-textbox>
    </ng-container>

    <ng-container *ngSwitchCase="ControllerTypes.TextArea">
      <detail-info-textarea
        class="w-100"
        [detailInfo]="detailInfo"
        [noDefaultValue]="noDefaultValue"
        [formControlObj]="control(detailInfo.evideInputContentGuid.toString())"
      ></detail-info-textarea>
    </ng-container>

    <ng-container *ngSwitchCase="ControllerTypes.Numeric">
      <detail-info-numeric-textbox
        class="w-100"
        [detailInfo]="detailInfo"
        [noDefaultValue]="noDefaultValue"
        [formControlObj]="control(detailInfo.evideInputContentGuid.toString())"
      ></detail-info-numeric-textbox>
    </ng-container>

    <ng-container *ngSwitchCase="ControllerTypes.Dropdown">
      <detail-info-select
        class="w-100"
        [detailInfo]="detailInfo"
        [noDefaultValue]="noDefaultValue"
        [formControlObj]="control(detailInfo.evideInputContentGuid.toString())"
      ></detail-info-select>
    </ng-container>

    <ng-container *ngSwitchCase="ControllerTypes.RadioButtons">
      <detail-info-radio
        class="w-100"
        [detailInfo]="detailInfo"
        [noDefaultValue]="noDefaultValue"
        [formControlObj]="control(detailInfo.evideInputContentGuid.toString())"
      ></detail-info-radio>
    </ng-container>

    <ng-container *ngSwitchCase="ControllerTypes.Checkboxes">
      <detail-info-checkbox
        class="w-100"
        [detailInfo]="detailInfo"
        [noDefaultValue]="noDefaultValue"
        [formControlObj]="control(detailInfo.evideInputContentGuid.toString())"
      ></detail-info-checkbox>
    </ng-container>

    <ng-container *ngSwitchCase="ControllerTypes.Checkbox">
      <detail-info-checkbox
        class="w-100"
        [detailInfo]="detailInfo"
        [noDefaultValue]="noDefaultValue"
        [formControlObj]="control(detailInfo.evideInputContentGuid.toString())"
      ></detail-info-checkbox>
    </ng-container>

    <ng-container *ngSwitchCase="ControllerTypes.DatePicker">
      <detail-info-datetime
        class="w-100"
        [detailInfo]="detailInfo"
        [noDefaultValue]="noDefaultValue"
        [bsConfig]="{
          rangeInputFormat: 'DD/MM/YYYY',
          dateInputFormat: 'DD/MM/YYYY'
        }"
        [formControlObj]="control(detailInfo.evideInputContentGuid.toString())"
      ></detail-info-datetime>
    </ng-container>

    <ng-container *ngSwitchCase="ControllerTypes.TimePicker">
      <detail-info-time-picker
        class="w-100"
        [detailInfo]="detailInfo"
        [noDefaultValue]="noDefaultValue"
        [bsConfig]="{ showMeridian: false }"
        [formControlObj]="control(detailInfo.evideInputContentGuid.toString())"
        [gridView]="gridView"
      ></detail-info-time-picker>
    </ng-container>

    <ng-container *ngSwitchCase="ControllerTypes.DateTimePicker">
      <detail-info-datetime
        class="w-100"
        [detailInfo]="detailInfo"
        [noDefaultValue]="noDefaultValue"
        [bsConfig]="{
          withTimepicker: true,
          keepDatepickerOpened: true,
          rangeInputFormat: 'DD/MM/YYYY, h:mm:ss a',
          dateInputFormat: 'DD/MM/YYYY, h:mm:ss a'
        }"
        [formControlObj]="control(detailInfo.evideInputContentGuid.toString())"
      ></detail-info-datetime>
    </ng-container>

    <ng-container *ngSwitchCase="ControllerTypes.Toggle">
      <detail-info-toggle
        class="w-100"
        [detailInfo]="detailInfo"
        [noDefaultValue]="noDefaultValue"
        [formControlObj]="control(detailInfo.evideInputContentGuid.toString())"
      ></detail-info-toggle>
    </ng-container>

    <ng-container *ngSwitchCase="ControllerTypes.DropdownMulti">
      <detail-info-multi-select
        class="w-100"
        [detailInfo]="detailInfo"
        [noDefaultValue]="noDefaultValue"
        [formControlObj]="control(detailInfo.evideInputContentGuid.toString())"
      ></detail-info-multi-select>
    </ng-container>

    <ng-container *ngSwitchCase="ControllerTypes.DropdownWithExtraText">
      <detail-info-select-with-text
        class="w-100"
        [detailInfo]="detailInfo"
        [noDefaultValue]="noDefaultValue"
        [formControlObj]="control(detailInfo.evideInputContentGuid.toString())"
      ></detail-info-select-with-text>
    </ng-container>

    <ng-container *ngSwitchCase="ControllerTypes.RepeatableTable">
      <div class="mb-3 w-100">
        <label class="form-label">
          {{ detailInfo.title }}<span *ngIf="detailInfo.isMandatory" class="text-danger">*</span>
        </label>
        <app-detail-info-repeatable-table
          [columns]="tableColumns"
          [rows]="rowsArray(detailInfo.evideInputContentGuid)">
        </app-detail-info-repeatable-table>
      </div>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <div style="margin-top: 10px">
        <small>
          Type <i>{{ detailInfo.controllerType }}</i> is not supported yet.
        </small>
      </div>
    </ng-container>
  </ng-container>
</div>
